import React from "react"
import styled from "styled-components"
import breakpoints from "@constants/breakpoints"
import { PromoProps } from "@components/PromoBanner/common"
import DesktopHeader from "./DesktopHeader"
import MobileHeader from "./MobileHeader"

const MobileContainer = styled.div`
  @media ${breakpoints.laptop} {
    display: none;
  }
`

const DesktopContainer = styled.div`
  display: none;
  @media ${breakpoints.laptop} {
    display: initial;
  }
`

interface HeaderProps {
  enterpriseLink: string
  supportLink: string
  onClickSearch?: (e) => void
  onClickCart?: (e) => void
  onClickMenu?: (e) => void
  onClickExplore?: (e) => void
  searchValue?: string
  megaMenuHeaderRef?: any
  megaMenuHeaderItems?: Array<{
    label: string
    onClick?: () => void
  }>
  megaMenuActiveItem?: string
  productCount?: number
  expanded?: boolean
  filters?:
    | {
        brand: {
          slug: string
          name: string
        }
        device: {
          slug: string
          name: string
          device: {
            slug: string
            name: string
          }
        }
      }
    | {}
  product?: object
  countdownTimer?: {
    eventStart: string
    eventEnd?: string
    textBeforeEvent: string
    textDuringEvent?: string
    textAfterEvent?: string
  }
  promos?: Array<PromoProps>
  promoScrollDelay: string
  collapsePromoBanner?: boolean
  showPromoBanner?: boolean
  showFilters?: boolean
  showFixedHeader?: boolean
  fixedHeaderTopRef?: any
  FixedHeaderComponent?: React.ReactNode
  shortenDesktopHeader?: boolean
  showRewardsPoints?: boolean
  rewardsPoints?: number
  isLoggedIn?: boolean
  onLogout?: () => void
}

const Header = (props: HeaderProps) => {
  return (
    <>
      <DesktopContainer>
        <DesktopHeader {...props} />
      </DesktopContainer>
      <MobileContainer>
        <MobileHeader {...props} />
      </MobileContainer>
    </>
  )
}

export default Header
